import React, { useState, useEffect, useMemo } from 'react';
import {
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from '@material-ui/core';
import { useHistory } from 'react-router';

import { config } from './config';
import { handleError } from '../../utils/config';
import Loading from '../../components/Loading/Loading';
import TitleHeader from '../../components/MasterComponent/TitleHeader/TitleHeader';
import SearchSelectOption from '../../components/MasterComponent/SelectOptions/SearchSelectOption';
// import { ALL_VALUE } from '../Invoice/config';
import { useFetchData } from '../../hooks/useFetchData';

interface Inventory {
  childern?: React.ReactNode;
  location?: {
    state?: {
      SubscriptionId: string;
      InventoryType: string;
    };
  };
}

export const Inventory: React.FC = (props: any) => {
  const history = useHistory();
  // const count = props.location.state.totalResourcesCount;
  const [loader, setLoader] = useState<any>(false);
  const [search, setSearch] = useState<any>('');
  const [inventoryDetails, setInventoyDetails] = useState([]);
  const [allInventoryDetails, setAllInventoyDetails] = useState([]);
  const [isNetworkError, setNetworkError] = React.useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string>('All');
  const [count, setCount] = useState(0);
  const accountId = props.location.state.selectedAccountId;
  const cloudProvider = props.location.state.cloudProvider;

  const params = {
    // page: pageNo,
    // subscriptionId,
    service:
      props.location && props.location.state && props.location.state.DataKey,
    accountId,
    cloudProvider,
  };

  const filterList = useFetchData({
    fetchData: () => config.getFilterTypeList(params),
    // dependencies: [],
    fetchOnMount: true,
  });

  const handleSearchChange = (event: any) => {
    setSearch(event.target.value);
  };

  // Format currency values
  const formatCurrency = (value: number | undefined): string => {
    if (value === undefined) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(value);
  };

  const handleSearchButton = () => {
    if (!search.trim()) {
      setInventoyDetails(allInventoryDetails); // Reset if empty
      return;
    }

    const searchTerm = search.toLowerCase().trim();

    const filteredData = allInventoryDetails.filter((resource: any) => {
      return (
        resource.resourceid.toLowerCase().includes(searchTerm) ||
        resource.billingtype.toLowerCase().includes(searchTerm)
      );
    });

    setInventoyDetails(filteredData);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleSearchButton();
    }
  };

  const getInventoryResourceDetails = async () => {
    try {
      setLoader(true);
      const params = {
        // page: pageNo,
        // subscriptionId,
        service:
          props.location &&
          props.location.state &&
          props.location.state.DataKey,
        accountId,
        cloudProvider,
        ...(selectedFilter === 'All' ? {} : { category: selectedFilter }),
      };

      const result: any = await config.getServiceResourceDetail(params);

      setCount(result.length);

      setInventoyDetails(result);
      setAllInventoyDetails(result);
      setSearch('');
    } catch (e: any) {
      if (e === 'Network Error') {
        setNetworkError(true);
      }
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getInventoryResourceDetails();
  }, [selectedFilter]);

  if (isNetworkError) {
    throw new Error('Network Error');
  }

  const filterOptionsWithLoading = useMemo(() => {
    if (filterList.loader) {
      return ['loading...']; // Show loader option
    }

    if (!filterList.data || filterList.data.length === 0) {
      return ['No filters available']; // Handle empty data
    }

    const categoryOptions = filterList.data.map(
      (item: { CostCategory: string }) => item.CostCategory
    );
    return ['All', ...categoryOptions];
  }, [filterList.data, filterList.loader]);

  // Handler that accounts for loading state
  const handleFilterChangeWithLoading = (event: any, value: string | null) => {
    const selectedValue = value || 'All';

    if (
      selectedValue === 'Loading...' ||
      selectedValue === 'No filters available'
    ) {
      return;
    }

    setSelectedFilter(selectedValue);
  };

  const totalCost = inventoryDetails?.reduce<number>((sum, service: any) => {
    return sum + Number(service.totalcost || 0);
  }, 0);

  return (
    <>
      {/* {loader ? <LoadingScreen /> : ''} */}

      <TitleHeader
        extraContent={
          <SearchSelectOption
            labelName="Filter"
            onChangeSelectHandler={handleFilterChangeWithLoading}
            selectOptions={filterOptionsWithLoading}
            selectedValue={filterList.loader ? 'Loading...' : selectedFilter}
            disableClearable={true}
          />
        }
      >
        {props.location &&
          props.location.state &&
          props.location?.state?.InventoryType === 'EC2'
          ? `Instance Profile${' - ' + selectedFilter}`
          : `${props.location?.state?.InventoryType}${' - ' + selectedFilter}`}
        <sup className="inventoryDetailCount font-15px fw-500 ml-10">
          {count}
        </sup>
      </TitleHeader>

      {/* <div className="rsTableHeader inventoryHeader mb-20">
          <div className="inventoryHeading">
            <div className="d-inline-block">
              {props.location &&
                props.location.state &&
                props.location.state.InventoryType}
            </div>

            <sup className="inventoryDetailCount font-20px fw-500 ml-20">
              {count}
            </sup>
          </div>

          <div className="w-55 mr-0 inventoryFlexContent">
            <TextField
              id="searchInventory"
              className=" w-80 inventoryFlexItem "
              label="SEARCH BY RESOURCE ARN/ID OR BILLING TYPE"
              variant="outlined"
              value={search}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
            />
            <button
              className="btn-primary btn ml-5 mr-0 inventoryFlexItem"
              onClick={handleSearchButton}
            >
              Search
            </button>
          </div>
        </div> */}
      <Grid item md={12} className="mb-10">
        <TableContainer
          className="accContainer"
          style={{ maxHeight: '70vh', overflowY: 'auto' }}
        >
          <Table
            className="table adminTable adminPanelTable"
            size="small"
            aria-label="a dense table"
            stickyHeader
          >
            <TableHead className="admintableHead">
              <TableRow>
                <TableCell className="adminTableheading">Account Id</TableCell>
                <TableCell className="adminTableheading">
                  Resource ARN / ID
                </TableCell>
                <TableCell className="adminTableheading">Region</TableCell>
                <TableCell className="adminTableheading">
                  Billing Type
                </TableCell>
                <TableCell className="adminTableheading">Total Cost</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Loading
                      style={{
                        height: 'fit-content',
                        padding: '2rem',
                      }}
                    />
                  </TableCell>
                </TableRow>
              ) : inventoryDetails?.length > 0 ? (
                <>
                  {inventoryDetails.map((service: any, index: number) => (
                  <TableRow className="accDetailRow" key={index}>
                    <TableCell
                      className="inventoryTableCell"
                      align="left"
                      // key={service + index}
                    >
                      {service.accountid}
                    </TableCell>
                    <TableCell
                      className="inventoryTableCell"
                      align="left"
                      // key={service + index}
                    >
                      {service.resourceid}
                    </TableCell>
                    <TableCell
                      className="inventoryTableCell"
                      align="left"
                      // key={service + index}
                    >
                      {service.region}
                    </TableCell>
                    <TableCell
                      className="inventoryTableCell"
                      align="left"
                      // key={service + index}
                    >
                      {service.billingtype}
                    </TableCell>
                    <TableCell
                      className="inventoryTableCell"
                      align="left"
                      // key={service + index}
                    >
                      ${Number(service.totalcost).toFixed(2)}
                    </TableCell>
                  </TableRow>
                    )
                  )}
                  <TableRow className="accDetailRow totalRow">
                    <TableCell
                      className="inventoryTableCell adminTableheading"
                      align="left"
                      colSpan={4}
                      style={{
                      position: 'sticky',
                      bottom: 0,
                      background: '#f5f5f5',
                      zIndex: 8,
                      fontWeight: 700,
                    }}
                    >
                      Total Cost
                    </TableCell>
                    <TableCell
                      className="inventoryTableCell adminTableheading"
                      align="left"
                      style={{
                        position: 'sticky',
                        bottom: 0,
                        background: '#f5f5f5',
                        color: 'rgba(10, 60, 162, 1)',
                        fontWeight: 700,
                        zIndex: 8,
                      }}
                    >
                      {formatCurrency(totalCost)}
                    </TableCell>
                  </TableRow>
                  </>
                ) : (
                <TableRow className="accDetailRow" key="No data">
                  <TableCell colSpan={5}>No Data Found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
};

export default React.memo(Inventory);
